<template>
  <div>
    <a-modal
      v-model="visible"
      :width="800"
      :confirmLoading="loading"
      :destroyOnClose="true"
      :maskClosable="false"
      centered
      @cancel="cancel"
      @ok="confirm"
    >
      <div slot="title">{{ $t("编辑计费规则") }}</div>
      <div>
        <a-form-model ref="form" :model="form" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="stock_in_transport_charge_unit" :label="$t('入库短驳计费单位')">
                <a-select v-model="form.stock_in_transport_charge_unit" allowClear style="width: 100%">
                  <a-select-option key="quantity" value="quantity">{{ $t("数量") }}</a-select-option>
                  <a-select-option key="weight" value="weight">{{ $t("吨") }}</a-select-option>
                  <a-select-option key="area" value="area">{{ $t("平方米") }}</a-select-option>
                  <a-select-option key="volume" value="volume">{{ $t("立方米") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_in_transport_unit_price" :label="$t('入库短驳单价(元)')">
                <a-input-number v-model="form.stock_in_transport_unit_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_in_handling_charge_unit" :label="$t('入库装卸计费单位')">
                <a-select v-model="form.stock_in_handling_charge_unit" allowClear style="width: 100%">
                  <a-select-option key="quantity" value="quantity">{{ $t("数量") }}</a-select-option>
                  <a-select-option key="weight" value="weight">{{ $t("吨") }}</a-select-option>
                  <a-select-option key="area" value="area">{{ $t("平方米") }}</a-select-option>
                  <a-select-option key="volume" value="volume">{{ $t("立方米") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_in_handling_unit_price" :label="$t('入库装卸单价(元)')">
                <a-input-number v-model="form.stock_in_handling_unit_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_out_transport_charge_unit" :label="$t('出库短驳计费单位')">
                <a-select v-model="form.stock_out_transport_charge_unit" allowClear style="width: 100%">
                  <a-select-option key="quantity" value="quantity">{{ $t("数量") }}</a-select-option>
                  <a-select-option key="weight" value="weight">{{ $t("吨") }}</a-select-option>
                  <a-select-option key="area" value="area">{{ $t("平方米") }}</a-select-option>
                  <a-select-option key="volume" value="volume">{{ $t("立方米") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_out_transport_unit_price" :label="$t('出库短驳单价(元)')">
                <a-input-number v-model="form.stock_out_transport_unit_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_out_handling_charge_unit" :label="$t('出库计费单位')">
                <a-select v-model="form.stock_out_handling_charge_unit" allowClear style="width: 100%">
                  <a-select-option key="quantity" value="quantity">{{ $t("数量") }}</a-select-option>
                  <a-select-option key="weight" value="weight">{{ $t("吨") }}</a-select-option>
                  <a-select-option key="area" value="area">{{ $t("平方米") }}</a-select-option>
                  <a-select-option key="volume" value="volume">{{ $t("立方米") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="stock_out_handling_unit_price" :label="$t('出库单价(元)')">
                <a-input-number v-model="form.stock_out_handling_unit_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="storage_charge_unit" :label="$t('仓储计费单位')">
                <a-select v-model="form.storage_charge_unit" allowClear style="width: 100%">
                  <a-select-option key="quantity" value="quantity">{{ $t("数量") }}</a-select-option>
                  <a-select-option key="weight" value="weight">{{ $t("吨") }}</a-select-option>
                  <a-select-option key="area" value="area">{{ $t("平方米") }}</a-select-option>
                  <a-select-option key="volume" value="volume">{{ $t("立方米") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="storage_unit_price" :label="$t('仓储单价(元)')">
                <a-input-number v-model="form.storage_unit_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>

        <div style="color: rgb(255, 77, 79); text-align: center">
          {{ $t("注意: 若点击确定, 该货主所有单品计费规则将被重置") }}
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { chargeClientSetRule } from "@/api/charge";

export default {
  props: ["visible", "form"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          chargeClientSetRule(this.form)
            .then((data) => {
              this.$message.success(this.$t("修改成功"));
              this.$emit("update", data);
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style scoped></style>
